import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import IndustrySave from "./IndustrySave";


const IndustryNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const handleFormSubmit = (e) => {

        let industryid = "";

        let valid = true;

        let industryname = "";
        if (document.getElementById("industryName").value != '') {
            industryname = document.getElementById("industryName").value;
        }
        else {
            valid = false;
            toast.error("Industry Name required");
        }
        let industrycode = "";
        if (document.getElementById("NAICSCode").value != '') {
            if (document.getElementById("NAICSCode").value.length < 10) {
                industrycode = document.getElementById("NAICSCode").value;
            }
            else {
                valid = false;
                toast.error("NAICS Code cannot exceed 10 characters");
            }
        }
        else {
            valid = false;
            toast.error("Industry Code required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if(valid) {
            IndustrySave(industryid, industryname, industrycode, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/Industry");
        }

    };

    document.title = "Industry - New";
    return ( 
        <div className="industryNew">

            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                    <h2>New Industry</h2>

                        <form id="industryForm" noValidate="novalidate" autoComplete="off">    

                            <div className="form-group">
                                <label htmlFor="industryName">Industry Name</label>
                                <input className="form-control" id="industryName" name="industryName" type="text" autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="NAICSCode">NAICS Code</label>
                                <input className="form-control" id="NAICSCode" name="NAICSCode" type="text" autocomplete="off" />
                            </div>

                        </form>  
                        <Link to="/Industry" className="btn btn-primary" style={{marginRight: "4px"}}>Cancel</Link>                          
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>
     );
}
 
export default IndustryNew;